// import Autoplay from 'embla-carousel-autoplay'
import { useRef, useState } from 'react'
import left_chevron from '../../assets/Auth/chevron_backward.svg'
import right_chevron from '../../assets/Auth/chevron_forward.svg'

const slides = [
  {
    graphic: 'goals',
    subtitle: 'Build wealth for financial milestones of your life',
    subtext:
      'From your next vacation to your retirement - build a corpus for all your financial obligations',
  },
  {
    graphic: 'portfolio',
    subtitle: 'Plan, invest in & track all your goals in one place',
    subtext: 'No more shuffling between spreadsheets & your demat accounts',
  },
  {
    graphic: 'advisor',
    subtitle: 'Get Professional Expertise for your Personal Finance',
    subtext: 'Create wealth with personalised strategies built by professionals',
  },
]

const darkGridStyle = {
  backgroundImage:
    'linear-gradient(to right, rgba(255, 255, 255, 0.05) 1px, transparent 1px), linear-gradient(to bottom, rgba(255, 255, 255, 0.05) 1px, transparent 1px)',
  backgroundSize: '48px 48px',
}

const SvgOnlyGraphic = ({ src, scale = 'scale-[1.52]' }) => (
  <img
    src={src}
    alt=''
    className={`absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2 object-contain ${scale}`}
  />
)

const MilestoneGraphic = () => (
  <SvgOnlyGraphic src='/Auth/login-life-ledger-calendar.svg' scale='scale-[1.7]' />
)

const PortfolioGraphic = ({ compact = false }) => (
  <SvgOnlyGraphic
    src='/Auth/login-one-place-stack.svg'
    scale={compact ? 'scale-[1.5]' : 'scale-[1.66]'}
  />
)

const AdvisorGraphic = () => (
  <SvgOnlyGraphic src='/Auth/login-private-strategy-puzzle.svg' scale='scale-[1.62]' />
)

const graphicComponents = {
  goals: MilestoneGraphic,
  portfolio: PortfolioGraphic,
  advisor: AdvisorGraphic,
}

const EditorialGraphic = ({ slide, compact = false }) => {
  const Graphic = graphicComponents[slide.graphic]

  return (
    <div
      className={`relative isolate mx-auto w-full max-w-full overflow-hidden ${
        compact
          ? 'h-[30svh] min-h-[168px] max-h-[230px] [@media(max-height:640px)]:h-[26svh] [@media(max-height:640px)]:min-h-[128px] [@media(max-height:640px)]:max-h-[148px] [@media(max-height:520px)]:h-[24svh] [@media(max-height:520px)]:min-h-[112px] [@media(max-height:520px)]:max-h-[132px]'
          : 'h-[360px] max-w-[472px]'
      }`}
      aria-hidden='true'
    >
      <Graphic compact={compact} />
    </div>
  )
}

export const AuthCarouselDesktop = () => {
  //   const plugin = React.useRef(Autoplay({ delay: 2000, stopOnInteraction: true }))
  const [currentSlide, setCurrentSlide] = useState(0)

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length)
  }

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)
  }

  return (
    <main className='p-0'>
      <div className='relative flex h-[calc(100vh-64px)] max-h-[680px] min-h-[600px] w-full max-w-[600px] flex-col items-center overflow-hidden rounded-[12px] bg-[#040313] px-10 py-10'>
        <div className='absolute inset-0 opacity-70' style={darkGridStyle} />
        <div className='relative flex h-full w-full flex-col items-center'>
          <div className='w-full flex-1 overflow-hidden'>
            <div
              className='flex h-full w-full transition-transform duration-500 ease-out'
              style={{
                transform: `translateX(-${currentSlide * 100}%)`,
              }}
            >
              {slides.map((slide, index) => (
                <div
                  key={index}
                  className='flex min-w-full flex-shrink-0 flex-col items-center justify-center'
                >
                  <EditorialGraphic slide={slide} />
                  <div className='mt-8 w-full max-w-[440px] space-y-3'>
                    <p className='text-center font-IBM text-[27px] font-bold leading-[1.12] tracking-normal text-[#f6f6f9]'>
                      {slide.subtitle}
                    </p>
                    <p className='mx-auto max-w-[392px] text-center font-IBM text-sm font-medium leading-5 text-[#b0b2c9]'>
                      {slide.subtext}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className='mt-8 flex h-8 w-[192px] items-center justify-between gap-4'>
            <button
              className='flex h-8 w-8 items-center justify-center rounded-full border border-white/10 bg-white/10'
              onClick={prevSlide}
            >
              <img src={left_chevron} alt='left-chevron' />
            </button>

            <div className='flex gap-2'>
              {slides.map((_, index) => (
                <button
                  key={index}
                  className={`h-1 rounded-full transition-all duration-200 ${
                    currentSlide === index ? 'w-[18px] bg-[#f6f6f9]' : 'w-1 bg-[#656992]'
                  }`}
                  onClick={() => setCurrentSlide(index)}
                ></button>
              ))}
            </div>

            <button
              className='flex h-8 w-8 items-center justify-center rounded-full border border-white/10 bg-white/10'
              onClick={nextSlide}
            >
              <img src={right_chevron} alt='right-chevron' />
            </button>
          </div>
        </div>
      </div>
    </main>
  )
}

export const AuthCarouselMobile = () => {
  //   const plugin = React.useRef(Autoplay({ delay: 2000, stopOnInteraction: true }))
  const [currentSlide, setCurrentSlide] = useState(0)
  const startX = useRef(0)
  const isDragging = useRef(false)

  const handleTouchStart = (e) => {
    isDragging.current = true
    startX.current = e.touches ? e.touches[0].clientX : e.clientX
  }

  const handleTouchMove = (e) => {
    if (!isDragging.current) return
    const currentX = e.touches ? e.touches[0].clientX : e.clientX
    const diff = startX.current - currentX

    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        nextSlide()
      } else {
        prevSlide()
      }
      isDragging.current = false
    }
  }

  const handleTouchEnd = () => {
    isDragging.current = false
  }

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length)
  }

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)
  }

  return (
    <div
      className='relative mx-auto flex h-full min-h-[100svh] w-full max-w-[430px] flex-col items-center justify-between overflow-hidden bg-[#040313] pb-[calc(152px+env(safe-area-inset-bottom))] pt-20 [@media(max-height:640px)]:pb-[calc(136px+env(safe-area-inset-bottom))] [@media(max-height:640px)]:pt-14 [@media(max-height:520px)]:pb-[calc(132px+env(safe-area-inset-bottom))] [@media(max-height:520px)]:pt-12'
      style={{ touchAction: 'pan-y' }}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      onMouseDown={handleTouchStart}
      onMouseMove={handleTouchMove}
      onMouseUp={handleTouchEnd}
    >
      <div className='absolute inset-0 opacity-70' style={darkGridStyle} />
      <div className='relative w-full min-w-0 overflow-hidden'>
        <div
          className='flex w-full transition-transform duration-500 ease-out'
          style={{
            transform: `translateX(-${currentSlide * 100}%)`,
          }}
        >
          {slides.map((slide, index) => (
            <div
              key={index}
              className='flex min-w-full max-w-full flex-shrink-0 flex-col items-center justify-start px-5'
            >
              <EditorialGraphic slide={slide} compact />
              <div className='mt-6 w-full max-w-full space-y-2 [@media(max-height:640px)]:mt-3 [@media(max-height:640px)]:space-y-1'>
                <p className='mx-auto max-w-[332px] text-center font-IBM text-[22px] font-bold leading-[1.14] tracking-normal text-[#f6f6f9] [@media(max-height:640px)]:max-w-[300px] [@media(max-height:640px)]:text-[17px] [@media(max-height:640px)]:leading-[1.12]'>
                  {slide.subtitle}
                </p>
                <p className='mx-auto max-w-[316px] overflow-hidden px-2 text-center font-IBM text-[13px] font-medium leading-5 text-[#b0b2c9] [@media(max-height:640px)]:hidden'>
                  {slide.subtext}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className='relative z-10 flex h-8 w-[192px] items-end justify-center gap-4'>
        <div className='flex gap-2'>
          {slides.map((_, index) => (
            <button
              key={index}
              className={`h-1 rounded-full transition-all duration-200 ${
                currentSlide === index ? 'w-[18px] bg-[#f6f6f9]' : 'w-1 bg-[#656992]'
              }`}
            ></button>
          ))}
        </div>
      </div>
    </div>
  )
}
